<mat-card appearance="outlined">
  <mat-card-header>
    <mat-icon mat-card-avatar class="email"></mat-icon>
    <mat-card-title class="card-title">{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="content-title">
      <strong>{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.DESCRIPTION' | translate }}</strong>
      <mat-icon [glxyTooltip]="'INBOX.SETTINGS.EMAIL_SETTINGS.SENDER_PREVIEW_INFO_DESCRIPTION' | translate">
        info_outline
      </mat-icon>
    </div>
    <div class="content-card">
      <mat-card appearance="outlined">
        <mat-card-header>
          <mat-icon mat-card-avatar class="icon">person</mat-icon>
          <mat-card-title>{{
            forwardingEmailTitle().translationKey | translate: forwardingEmailTitle()
          }}</mat-card-title>
          <mat-card-subtitle><{{ this.forwardingAddress() }}></mat-card-subtitle>
        </mat-card-header>
      </mat-card>
    </div>
    <glxy-form-field>
      <glxy-label>{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.FORWARDING_ADDRESS' | translate }}</glxy-label>
      <input disabled type="text" placeholder="{{ this.forwardingAddress() }}" matInput />
      <button
        mat-icon-button
        matSuffix
        (click)="copyClicked()"
        [glxyTooltip]="
          (isCopied ? 'INBOX.COMMON.SNACK_BAR_MESSAGE.COPY_SUCCESS' : 'INBOX.COMMON.SNACK_BAR_MESSAGE.CLICK_TO_COPY')
            | translate
        "
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <glxy-hint>
        {{ 'INBOX.SETTINGS.EMAIL_SETTINGS.SENDER_PREVIEW_INFO_DESCRIPTION' | translate }}
        <a (click)="openLearnMoreModal()">{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.LEARN_MORE' | translate }}</a>
      </glxy-hint>
    </glxy-form-field>
  </mat-card-content>
</mat-card>
